import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 px-4 bg-cream-alt relative overflow-hidden" data-id="element-182">
      <div className="max-w-4xl mx-auto" data-id="element-183">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="bg-cream rounded-3xl p-8 md:p-16 shadow-xl border border-gold-start/20 relative z-10" data-id="element-184">
          <div className="text-center mb-12" data-id="element-185">
            <motion.span variants={itemVariants} className="inline-block uppercase tracking-widest text-sm font-bold text-gold-end mb-4" data-id="element-186">
              Presentamos
            </motion.span>
            <motion.h2 variants={itemVariants} className="text-4xl md:text-5xl lg:text-6xl font-bold text-brown mb-8" data-id="element-187">
              MEGA PACK CLARIDAD MENTAL
            </motion.h2>
            <motion.p variants={itemVariants} className="text-lg md:text-xl text-brown-light max-w-2xl mx-auto" data-id="element-188">
              Un sistema simple basado en enseñanzas contemplativas que te
              ayudará a:
            </motion.p>
          </div>

          <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 max-w-3xl mx-auto" data-id="element-189">
            {['entender cómo funciona tu mente', 'dejar de sobrepensar', 'controlar mejor tus emociones', 'recuperar la calma mental'].map((item, i) => <div key={i} className="flex items-center gap-4 bg-cream-alt p-4 rounded-xl" data-id="element-190">
                <CheckCircle2 className="w-6 h-6 text-gold-end shrink-0" data-id="element-191" />
                <span className="text-lg font-medium text-brown" data-id="element-192">{item}</span>
              </div>)}
          </motion.div>

          <motion.div variants={itemVariants} className="text-center space-y-4 text-lg md:text-xl text-brown-light font-medium" data-id="element-193">
            <p data-id="element-194">Todo explicado de forma clara y práctica.</p>
            <p data-id="element-195">Sin técnicas complicadas.</p>
            <p className="text-gold-end font-bold" data-id="element-196">
              Solo herramientas que puedes aplicar desde el primer día.
            </p>
            <div className="flex items-center justify-center gap-2 mt-6 pt-6 border-t border-brown/10" data-id="element-197">
              <span className="text-2xl" data-id="element-198">📩</span>
              <p className="text-brown font-bold" data-id="element-199">
                El PDF llega al instante a tu correo y a tu WhatsApp
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}